module.exports = __webpack_public_path__ + "img/2.4a9bb055.jpg";